(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-wrapper');
      this.headerMain = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // Initial header height check based on screen size
      this.checkScreenSizeAndSetHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.checkScreenSizeAndSetHeight.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    checkScreenSizeAndSetHeight() {
      // Use requestAnimationFrame to debounce the height setting
      requestAnimationFrame(() => {
        if (window.matchMedia('(max-width: 1024px)').matches) {
          this.setHeaderHeight();
        } else {
          this.setHeaderHeight();
        }
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling DOWN past the header
        this.headerMain.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling UP while past the header - show the header
        this.headerMain.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        // At the top of the page
        this.headerMain.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.headerMain.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.headerMain.classList.add('shopify-section-header-sticky', 'animate');
      this.headerMain.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.headerMain.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability"] && !window.DesignMode) return;
  try {
    
  class SustainabilitySlider extends HTMLElement {
    constructor() {
      super();
      console.log('SustainabilitySlider constructor called');

      this.slider = this.querySelector('.sustainability-list');
      this.slides = this.querySelectorAll('.slider__slide');
      this.prevButton = this.querySelector('.slider-button--prev');
      this.nextButton = this.querySelector('.slider-button--next');
      this.counter = this.querySelector('.slider-counter--current');

      console.log('Elements found:', {
        slider: !!this.slider,
        slidesCount: this.slides.length,
        prevButton: !!this.prevButton,
        nextButton: !!this.nextButton,
        counter: !!this.counter,
      });

      if (!this.slider || !this.slides.length || !this.prevButton || !this.nextButton || !this.counter) {
        console.log('Missing required elements, slider initialization stopped');
        return;
      }

      this.currentSlide = 0;
      this.isTransitioning = false;
      this.init();
    }

    init() {
      console.log('Initializing slider');
      // Set initial state
      this.updateSlider();

      // Add event listeners
      this.prevButton?.addEventListener('click', () => {
        console.log('Previous button clicked');
        this.showPrevSlide();
      });

      this.nextButton?.addEventListener('click', () => {
        console.log('Next button clicked');
        this.showNextSlide();
      });

      console.log('Slider initialized successfully');
    }

    showPrevSlide() {
      if (this.isTransitioning) {
        console.log('Transition in progress, ignoring click');
        return;
      }
      this.handleSlideChange('prev');
    }

    showNextSlide() {
      if (this.isTransitioning) {
        console.log('Transition in progress, ignoring click');
        return;
      }
      this.handleSlideChange('next');
    }

    async handleSlideChange(direction) {
      console.log(`Handling slide change: ${direction}`);
      this.isTransitioning = true;

      // Store current height of the slider
      const currentHeight = this.slider.offsetHeight;
      this.slider.style.height = `${currentHeight}px`;

      // Add fade-out class to current slide
      this.slides[this.currentSlide].classList.add('fade-out');

      // Wait for fade animation
      await new Promise((resolve) => setTimeout(resolve, 400));

      // Calculate new slide index
      this.currentSlide =
        direction === 'prev'
          ? (this.currentSlide - 1 + this.slides.length) % this.slides.length
          : (this.currentSlide + 1) % this.slides.length;

      console.log(`Moving to slide: ${this.currentSlide + 1}`);

      // Update slider display
      this.updateSlider();

      // Wait for new slide to be positioned
      await new Promise((resolve) => setTimeout(resolve, 100));

      // Get height of new slide and update slider height
      const newHeight = this.slides[this.currentSlide].offsetHeight;
      this.slider.style.height = `${newHeight}px`;

      // Remove fade-out class and reset transition state
      this.slides.forEach((slide) => slide.classList.remove('fade-out'));

      // After transition completes, remove fixed height
      setTimeout(() => {
        this.slider.style.height = '';
        this.isTransitioning = false;
      }, 400);
    }

    updateSlider() {
      console.log('Updating slider display');
      this.slides.forEach((slide, index) => {
        if (index === this.currentSlide) {
          slide.classList.add('active');
          slide.classList.remove('inactive');
        } else {
          slide.classList.remove('active');
          slide.classList.add('inactive');
        }
      });

      if (this.counter) {
        this.counter.textContent = this.currentSlide + 1;
      }
    }
  }

  console.log('Attempting to register SustainabilitySlider component');
  if (!customElements.get('sustainability-slider')) {
    customElements.define('sustainability-slider', SustainabilitySlider);
    console.log('SustainabilitySlider component registered successfully');
  } else {
    console.log('SustainabilitySlider component was already registered');
  }

  } catch(e) { console.error(e); }
})();
})();
